
import { Card, modalService, toastService } from "@vaettyr/boltcave-client-core";
import { inject, observer } from 'mobx-react';
import { Prize } from '../../../type';
import { deleteItemToasts } from "../../../utility/toast.utility";
import PrizeStore from "../../../stores/prizeStore";

type PrizeDeleteProps = {
  prizestore?: PrizeStore,
  prize: Prize,
  modalservice?: modalService,
  toastservice?: toastService
}

export const modalName = "prize-delete";

export default inject('prizestore', 'modalservice', 'toastservice') ( observer (
  ({ prize, prizestore, modalservice, toastservice }: PrizeDeleteProps ) => {

    const onDelete = () => {
      const { success, failure } = deleteItemToasts(toastservice, 'prize')
      prizestore?.remove(prize)
        .then(() => {
            modalservice?.hide(modalName);
            success();
        })
        .catch(failure);
    }

    const onCancel = () => modalservice?.hide(modalName);

    const actions = (
      <>
        <button type="button" className="card-footer-item button is-primary" onClick={onDelete}>Yes</button>
        <button className="card-footer-item button" onClick={onCancel}>No</button>
      </>
    )

    return (
      <Card header={`Delete Prize`} footer={actions}>
        <p>Are you sure you want to delete this prize?</p>
      </Card>
    )
  }
));